import React from 'react'
import {Route} from 'react-router'
import {StandardLayout} from 'common/layouts/StandardLayout'
import {OrganizationsSearch} from './OrganizationsSearch'
import {ExperiencesBillingContainer} from './ExperiencesBilling'

const AppWrapper = ({children}) => (
  <StandardLayout greyBg>
    {children}
  </StandardLayout>
)

export const routes = (
  <Route component={AppWrapper}>
    <Route path='search' component={OrganizationsSearch} />
    <Route path=':organizationId/experiences_billing' component={ExperiencesBillingContainer} />
  </Route>
)
